module.exports = __webpack_public_path__ + "img/Web_hosting.f3986d78.svg";